import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { EditSellerPage } from "@/modules/user";
import { requireAuthAndPermission } from "@/utils";

export const Route = createFileRoute("/users/sellers/$sellerId")({
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Edit Seller"
        description="Edit seller account details."
      />
      <EditSellerPage />
    </>
  )
});
